<script setup>
import { useI18n } from "vue-i18n";
import { Link, usePage } from '@inertiajs/vue3';
const page = usePage()
const company = page.props.shared_data.company
const primaryPhone = company['phone'].split(",")
const { locale } = useI18n();

import axios from "axios";
import { onMounted, ref } from "vue";

const apps_banner = ref({});

async function getAppsBanner() {
    try {
        const res = await axios.get("/apps-banner-data");
        apps_banner.value = res.data || {};
    } catch (error) {
        console.error("Error fetching :", error);
    }
}

onMounted(() => {
    getAppsBanner();
});
</script>
<template>
    <section class="text-gray-600" v-if="apps_banner?.status == true">
        <div
            class="container 2xl:px-56 xl:px-16 lg:pt-4 sm:pt-8 mx-auto lg:pb-4"
        >
            <div class="pb-6 wow animate__animated animate__fadeInLeft">
                <h2
                    class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl lg:mt-4 mb-2"
                >
                    {{
                        locale === "BN"
                            ? apps_banner?.bn_heading
                            : apps_banner?.heading
                    }}
                </h2>
                <h3
                    class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-2xl lg:text-xl sm:text-lg text-base mb-4"
                >
                    {{
                        locale === "BN"
                            ? apps_banner?.bn_sub_heading
                            : apps_banner?.sub_heading
                    }}
                </h3>
                <div
                    class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"
                ></div>
            </div>
            <div class="flex flex-wrap">
                <div
                    class="lg:w-1/2 w-full md:mx-auto lg:pt-4 lg:pl-32 bg-white wow animate__animated animate__fadeInRight"
                >
                    <div
                        class="h-full w-full mx-auto justify-center flex items-center"
                    >
                        <VLazyImage
                            :src="apps_banner?.app_image"
                            alt="apps-image"
                            class="xl:h-[540px] xl:w-[280px] h-[410px] w-[220px] object-cover object-center inline-block bg-white"
                        />
                    </div>
                </div>
                <div
                    class="lg:w-1/2 w-full lg:mb-0 p-4 lg:mt-14 mt-4 wow animate__animated animate__fadeInLeft"
                >
                    <div class="lg:mb-10 mb-4">
                        <div class="flex flex-wrap">
                            <div
                                class="xl:w-36 w-24 xl:h-36 h-24 mr-4 border-gray-400 border-2 p-1"
                            >
                                <VLazyImage
                                    :src="apps_banner?.apk_qr_image"
                                    alt="android-qr-code-image"
                                    width="144"
                                    height="144"
                                    class="mb-2 rounded-lg"
                                />
                            </div>

                            <div>
                                <VLazyImage
                                    :src="apps_banner?.google_play_image"
                                    class="w-full xl:h-24 h-16 barcode-icon"
                                    alt="google-play-image"
                                />
                                <a
                                    :href="apps_banner?.apk_download_link"
                                    class="border bg-[#F9B63C] hover:bg-primary hover:text-white rounded-md transition duration-300 flex justify-center items-center py-1 lg:px-3 px-2 tracking-wider font-bold text-black xl:text-2xl text-base text-center"
                                    target="__blank"
                                    >{{ $t("common.download_now") }}</a
                                >
                            </div>
                        </div>
                    </div>

                    <div>
                        <span
                            class="border bg-[#F9B63C] hover:bg- rounded-md transition duration-300 justify-center items-center py-1 px-3 tracking-wider font-bold text-black xl:text-2xl text-base text-center"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_one
                                    : apps_banner?.label_one
                            }}
                        </span>
                        <h3
                            class="mt-2 text-black font-semibold 2xl:text-6xl xl:text-6xl lg:text-[36px] text-[22px] leading-tight"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_two
                                    : apps_banner?.label_two
                            }}
                        </h3>

                        <h3
                            class="mb-2 text-black font-medium 2xl:text-[45px] xl:text-[40px] lg:text-[36px] text-[18px] leading-tight"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_three
                                    : apps_banner?.label_three
                            }}
                        </h3>
                        <!-- <span
                            class="mt-4 border bg-[#F9B63C] hover:bg- rounded-md transition duration-300 justify-center items-center py-1 px-6 tracking-wider font-bold text-white xl:text-4xl text-base text-center"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_four
                                    : apps_banner?.label_four
                            }}
                        </span> -->

                        <!-- <p
                            class="sm:mt-3 mt-2 font-semibold text-black sm:text-2xl text-base leading-relaxed"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_five
                                    : apps_banner?.label_five
                            }}
                        </p> -->
                    <div class="flex mt-4">  
        <a :href="`tel:`+primaryPhone[0]" class="flex items-center justify-center bg-primary sm:px-4 px-2 py-[5px] rounded-full text-center text-gray-700 sm:text-[15px] text-[13px] font-semibold border border-primary uppercase tracking-wider cursor-pointer hover:bg-[#1565C0] hover:border-[#1565C0] transition duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                class="sm:w-6 w-4 sm:h-6 h-4 mr-2">
                <path fill-rule="evenodd" d="M2 3.5A1.5 1.5 0 0 1 3.5 2h1.148a1.5 1.5 0 0 1 1.465 1.175l.716 3.223a1.5 1.5 0 0 1-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 0 0 6.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 0 1 1.767-1.052l3.223.716A1.5 1.5 0 0 1 18 15.352V16.5a1.5 1.5 0 0 1-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 0 1 2.43 8.326 13.019 13.019 0 0 1 2 5V3.5Z" clip-rule="evenodd" />
            </svg> {{$t('common.consultation')}} </a>
            </div> 
    
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
